<script setup lang="ts">
type UIColor = 'success' | 'info' | 'secondary' | 'warning' | 'error'

const props = defineProps<{
  under200k: string
  range200k400k: string
  range400k600k: string
  range600k1m: string
  over1m: string
}>()

const parseCount = (value: string) => Number(value?.replace(/\D/g, '') || 0)

const ranges = computed(() => {
  const rows: Array<{ label: string, count: number, color: UIColor }> = [
    { label: 'Onder €200.000', count: parseCount(props.under200k), color: 'success' },
    { label: '€200.000 - €400.000', count: parseCount(props.range200k400k), color: 'info' },
    { label: '€400.000 - €600.000', count: parseCount(props.range400k600k), color: 'secondary' },
    { label: '€600.000 - €1.000.000', count: parseCount(props.range600k1m), color: 'warning' },
    { label: 'Boven €1.000.000', count: parseCount(props.over1m), color: 'error' },
  ]
  const total = rows.reduce((sum, r) => sum + r.count, 0)
  return rows.map(r => ({ ...r, percentage: total > 0 ? Math.round((r.count / total) * 100) : 0 }))
})
</script>

<template>
  <div class="not-prose space-y-4 my-6">
    <div
      v-for="range in ranges"
      :key="range.label"
      class="space-y-1"
    >
      <div class="flex justify-between text-sm">
        <span class="font-medium text-default">{{ range.label }}</span>
        <span class="text-muted">{{ formatNumber(range.count) }} woningen ({{ range.percentage }}%)</span>
      </div>
      <UProgress
        :model-value="range.percentage"
        :max="100"
        size="sm"
        :color="range.color"
      />
    </div>
  </div>
</template>
